import React, { useState, FormEvent } from "react";
import CustomButton from '../buttons/Button'
import { AuthFormProps, LoginFormProps } from "../../../types/form";
import FormInputText from "./FormInputText";
import { validateInput } from "../../../utilities/formValidator";

function AuthForm(props: AuthFormProps) {
    const [values, setValues] = useState({
        email: '',
        password: '',
        appName: ''
    });
    const [preview, setPreview] = useState(false)
    const [errorFields, setErrorFields] = useState({
        email: '',
        password: '',
        appName: ''
    });

    function handlePreview() {
        setPreview(!preview)
    }

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = event.target;

        setValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    function handleFormValidation(data: LoginFormProps) {
        const errors = {} as Record<string, string>;
      
        try {
            if (typeof data !== 'object') {
              throw new Error('Data must be an object');
            }

            for (const [key, value] of Object.entries(data)) {
                const result = validateInput(key, value);
                if (result?.isKey === true && result?.test === false) {
                    errors[key] = result.errMsg
                }
            }
            
            setErrorFields((prevState) => ({
                ...prevState,
                ...errors
            }));    
            
            return Object.keys(errors).length ? errors : undefined;
        } catch (error) {
            throw new Error("Failed validation")
        }
    }

    function handleFormSubmit(event: FormEvent<HTMLFormElement>) {        
        event.preventDefault();
        
        // run form validation
        const validatedValues = handleFormValidation(values);

        if (typeof validatedValues !== 'undefined') {
            return;
        }
        props.onSubmit(values);
    }

    return (
        <form 
            className="modal-form login-form" 
            method="post" 
            onSubmit={handleFormSubmit}
        >
            <FormInputText 
                id='email'
                name='email'
                label="Email address"
                placeholder='Enter email address here'
                type="text" 
                className="mb--15"
                value={values.email}
                onChange={handleChange}
                errMsg={errorFields['email']}
            />

            <FormInputText 
                id='password'
                name='password'
                label="Password"
                placeholder='Enter password here'
                className="mb--15"
                value={values.password}
                showPassword={preview}
                type={preview ? 'text': 'password'} 
                errMsg={errorFields['password']}
                togglePassword={handlePreview}
                onChange={handleChange}
            />  

            <FormInputText 
                id='appName'
                name='appName'
                label="Application Name"
                placeholder='Please input your application name!'
                value={values.appName}
                errMsg={errorFields['appName']}
                type="text" 
                onChange={handleChange}
            />  

            <CustomButton
                disabled={props.isLoading ? true : false}
                width='100%'
                cta='primary'
                type='submit'
                loading={props.isLoading}
                label="SIGN IN"
                isIcon={false}
                className="mt--15"
            />
        </form>
    )
}

export default AuthForm